module.exports = __webpack_public_path__ + "images/backgrounds/ocean/full.4ce437330ab9d2fe40dd.jpg";